/**
 * Tipo de liquidación (`SettlementTypeEnum` de Settlements.API). Las liquidaciones viejas pueden tener `0`
 * (el front las creaba así): para ésas el tipo se resuelve por asociaciones (`resolveSettlementKind`).
 */
export enum SettlementTypeEnum {
  Agreement = 1,
  Practitioner = 2,
  Protocol = 3,
  /** Liquidación de proveedor (Settlements 004, spec 010). */
  Provider = 4,
}
